const targets = Array.from(
  document.querySelectorAll<HTMLSelectElement>('.js-form-dropdown'),
);

if (targets.length) {
  import('./formDropdown').then(({ default: Dropdown }) => {
    targets.map((x) => Dropdown(x).init());
  });
}

export {};
